export const toBeConfigured = 'to-be-configured';
export const inReview = 'in-review';
export const approved = 'approved';
export const toBeReScanned = 'to-be-rescanned';
export const fixtureStatus = [toBeConfigured, inReview, approved, toBeReScanned] as const;
export type FixtureStatus = typeof fixtureStatus[number];
